// eslint-disable-next-line import/extensions
import { yupResolver } from '@hookform/resolvers/yup';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { getConfirmationFormData } from './helpers';
import { PreApprovalConfirmationFormInner } from './PreApprovalConfirmationFormInner';
import { schema } from './schema';
import type { PreApprovalConfirmationFormProps } from './types';

export const PreApprovalConfirmationForm: FC<PreApprovalConfirmationFormProps> = (props) => {
  const [isMounted, setIsMounted] = useState(false);

  const form = useForm({
    resolver: yupResolver(schema()),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  useEffect(() => {
    form.reset(getConfirmationFormData(), { keepErrors: true, keepDirtyValues: true });
    setIsMounted(true);
  }, [form]);

  if (!isMounted) {
    return null;
  }

  return (
    <FormProvider {...form}>
      <PreApprovalConfirmationFormInner {...props} />
    </FormProvider>
  );
};
